import request from 'admin-ng/util/request-promise';
import {USERS} from '.';

export const all = params => request(USERS, 'get', params);
export const create = params => request(USERS, 'post', params);
export const update = (id, params) => request(`${USERS}${id}`, 'put', params);
